'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import CourseChapterHeader from '../../../[chapterSlug]/_components/CourseChapterHeader';
import TocToggler from '../../../[chapterSlug]/_components/TocToggler';
import { useChapterContext } from '../../../[chapterSlug]/_contexts/ChapterContext';
import useTocState from '../../../_hooks/useTocState';
import AnonymousLoginBanner from './AnonymousLoginBanner';
import QuizSkeleton from './QuizSkeleton';
const Title = styled(Typography)(({
  theme: {
    spacing
  }
}) => ({
  margin: spacing(4, 0, 5, 0)
}));
interface Props {
  exerciseId: number;
  isTocInitiallyOpen: boolean;
}
export default function PageAnonymous(t0) {
  const $ = _c(23);
  const {
    exerciseId,
    isTocInitiallyOpen
  } = t0;
  const headerRef = useRef(null);
  const [isTocOpen, setIsTocOpen] = useTocState(isTocInitiallyOpen);
  const {
    course,
    flatToc
  } = useChapterContext();
  if (!course) {
    return null;
  }
  let t1;
  if ($[0] !== exerciseId || $[1] !== flatToc) {
    t1 = flatToc?.find(item => item.id === exerciseId);
    $[0] = exerciseId;
    $[1] = flatToc;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentExercise = t1;
  let t2;
  if ($[3] !== course.categoryColor) {
    t2 = {
      "--categoryColor": course.categoryColor
    };
    $[3] = course.categoryColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = t2 as React.CSSProperties;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CourseChapterHeader headerRef={headerRef} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      position: "relative",
      pb: 2
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isTocOpen || $[8] !== setIsTocOpen) {
    t6 = <TocToggler headerRef={headerRef} isOpen={isTocOpen} setIsOpen={setIsTocOpen} />;
    $[7] = isTocOpen;
    $[8] = setIsTocOpen;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      position: "relative"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = currentExercise?.title;
  let t9;
  if ($[11] !== t8) {
    t9 = <Title variant="h2">{t8}</Title>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <AnonymousLoginBanner title={translate("quizpage.not_logged.login_banner.title")} description={translate("quizpage.not_logged.login_banner.desc")} />;
    t11 = <QuizSkeleton />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t9) {
    t12 = <ContentWrapper variant="narrow" sx={t7}>{t9}{t10}{t11}</ContentWrapper>;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t6) {
    t13 = <Box sx={t5}>{t6}{t12}</Box>;
    $[17] = t12;
    $[18] = t6;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t3) {
    t14 = <div style={t3}>{t4}{t13}</div>;
    $[20] = t13;
    $[21] = t3;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
}